(function() {
    angular
        .module('app')
        .directive('gRuta', gRuta);

    gRuta.$inject = ['$timeout', '$parse', '$window','mapsService','espaiService'];

    function gRuta($timeout, $parse, $window,mapsService,espaiService) {
        return {
            restrict: 'A',
            scope: {
         		ruta: '=',
         		espais: '='
      		},
            link: function(scope, element, $attrs) {

                return $timeout(function() {
                    //Attribute definitions
                    var value = $attrs.value,
                        $element = $(element),
                        id = $attrs.id;
                        
                    var bounds;
                        //Elimina el benvinguts al clickar en el mapa
                        

					var	map = new google.maps.Map(document.getElementById(id), {
  								center: {lat:41.390205, lng: 2.154007},
  								zoom: 8
						});

					Polyline = function(punts_json){
			
						    var obj = JSON.parse(punts_json);

	       	  		var flightPlanCoordinates = [];
	       	  		bounds = new google.maps.LatLngBounds();
    		   			for (var i = 0; i < obj.length; i++) {
	       					var LatLong = new google.maps.LatLng(obj[i][0], obj[i][1]);
            				
            			bounds.extend(LatLong);
            				
       						flightPlanCoordinates.push({lat: obj[i][0], lng: obj[i][1]});
       					}

       					var flightPath = new google.maps.Polyline({
       	  					path: flightPlanCoordinates,
       	  					geodesic: true,
       	  					strokeColor: '#b5b92d',
       	  					strokeOpacity: 0.5,
       	  					strokeWeight: 4
       					});

       					flightPath.setMap(map);
       					map.fitBounds(bounds);
            		map.setCenter(bounds.getCenter());
		    		};

		    		markers = function(espais)
		    		{
               var c = new google.maps.LatLngBounds();

		    			for (var i = 0; i < espais.length; i++) {
		    				
		    				var espai = espaiService.getEspaiByID(espais[i]);
                
		    				var image={
                        		url : "/api/v1/image?autor="+espai.data.autor+"&color=1",
                        		size: new google.maps.Size(63, 63),
                        		// The origin for this image is (0, 0).
                        		origin: new google.maps.Point(0, 0),
                        		// The anchor for this image is the base of the flagpole at (0, 32).
                        		anchor: new google.maps.Point(0, 63)
                    		};
    			 
    			    	var LatLong = new google.maps.LatLng(espai.data.latitud, espai.data.longitud);
                c.extend(LatLong);
    			    	var marker = new google.maps.Marker({
                    		position: LatLong,
                    		map: map,
                    		title: espai.data.nom_ca,
                    		icon: image,
                    		espai_id: espai.id,
                        	
            	    	});

		    			}
              if(scope.ruta.punts_json===undefined)
              {
                //map.fitBounds(c);
                map.setZoom( 17 );
                map.setCenter(c.getCenter());
                

              }
		    			
		    		};
            var a = [];
            if(typeof scope.espais === 'number')
            {
              
                a.push(scope.espais);
              
            }else{
              for (var i = 0; i < scope.espais.length; i++)
		    		    a.push(scope.espais[i].espai_id);
            }
            markers(a);
            if(scope.ruta.punts_json!==undefined)
		    		  Polyline(scope.ruta.punts_json);

					

                });

            }
        };
    }

})();
